import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { NavMarker } from 'react-rhumb';
import { PageSubTitle, PageTitle } from 'pricing-pages-ui-components/semantic/PageHeader';
import { PageSection } from 'pricing-pages-ui-components/semantic/PageSection';
import { CreditsCallout } from '../../../components/common/credits-callout/CreditsCallout';
import PhoneSupportFooter from '../../components/phone-support/PhoneSupportFooter';
import { BannerSection } from '../../containers/BannerSection';
import { IntegrationsSection } from '../../containers/IntegrationsSection';
import { MarketingPlusFeatureTable } from './MarketingPlusFeatureTable';
import { MarketingPlusMerchCards } from './MarketingPlusMerchCards';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MARKETING_PLUS_API_NAMES = ['marketing-plus-professional-bundle', 'marketing-plus-enterprise-bundle'];
export const MarketingPlusPage = () => {
  return /*#__PURE__*/_jsxs(NavMarker, {
    name: "MARKETING_PLUS_PAGE_V2",
    children: [/*#__PURE__*/_jsx(BannerSection, {
      screen: "MARKETING_PLUS",
      apiNames: MARKETING_PLUS_API_NAMES
    }), /*#__PURE__*/_jsxs(View, {
      textAlign: "center",
      marginBlockEnd: "800",
      children: [/*#__PURE__*/_jsx(PageTitle, {
        "aria-level": 1,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.pagesV2.marketingPlus.pageTitle"
        })
      }), /*#__PURE__*/_jsx(PageSubTitle, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.pagesV2.marketingPlus.description"
        })
      })]
    }), /*#__PURE__*/_jsx(PageSection, {
      children: /*#__PURE__*/_jsx(MarketingPlusMerchCards, {})
    }), /*#__PURE__*/_jsx(PageSection, {
      children: /*#__PURE__*/_jsx(CreditsCallout, {
        navItem: "marketing-plus"
      })
    }), /*#__PURE__*/_jsx(PageSection, {
      children: /*#__PURE__*/_jsx(MarketingPlusFeatureTable, {})
    }), /*#__PURE__*/_jsx(IntegrationsSection, {
      nav: "marketing-plus"
    }), /*#__PURE__*/_jsx(PhoneSupportFooter, {
      phoneSourceId: "marketingplus-footer",
      screen: "marketing-plus",
      apiName: "marketing-plus-professional-bundle"
    })]
  });
};